app.QuizList = app.AbstractCollection.extend({
  model: app.Quiz,

  url() {
    return '/api/v2/quizzes';
  },
});
